<template>
  <div class="col-12 connections py-4 mb-4">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Долги</h5>
      </div>
      <div class="card-body">
        <template v-if="enforcements?.length">
          <div class="debts-summary row gy-3 mb-4">
            <div class="col-md-4">
              <div class="debts-summary__item">
                <span class="label">Производств</span>
                <strong>{{ enforcements.length }}</strong>
              </div>
            </div>
            <div class="col-md-4">
              <div class="debts-summary__item">
                <span class="label">Сумма задолженности</span>
                <strong>{{ formatCurrency(totalAmountDebt) }}</strong>
              </div>
            </div>
            <div class="col-md-4">
              <div class="debts-summary__item">
                <span class="label">Остаток задолженности</span>
                <strong>{{ formatCurrency(totalBalanceDebt) }}</strong>
              </div>
            </div>
          </div>

          <div class="connections-list-container">
            <div v-for="enforcement in enforcements" :key="enforcement.id" class="connections-list">
              <div class="connections-list__header">
                <p>
                  № {{ enforcement.enforcements_number || 'без номера' }}
                  <span v-if="enforcement.enforcements_date">
                    от {{ formatDate(enforcement.enforcements_date) }}
                  </span>
                </p>
              </div>
              <div class="connections-list__body col-10">
                <p class="value"><span class="label">Должник</span>{{ enforcement.company_name || 'Нет данных' }}</p>
                <p class="value"><span class="label">Предмет исполнения</span>{{ enforcement.subject_execution || 'Нет данных' }}</p>
                <p class="value"><span class="label">Сумма долга</span>{{ formatCurrency(enforcement.amount_debt) }}</p>
                <p class="value"><span class="label">Остаток</span>{{ formatCurrency(enforcement.balance_debt) }}</p>
                <p class="value"><span class="label">Документ</span>{{ enforcement.document_type || 'Нет данных' }}</p>
                <p class="value"><span class="label">Отдел приставов</span>{{ enforcement.departament_name || 'Нет данных' }}</p>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <p class="text-center mb-0">Нет данных об исполнительных производствах</p>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import { computed, defineComponent } from 'vue';
  import moment from 'moment';

  export default defineComponent({
    name: 'Debts',
    props: {
      enforcements: {
        type: Array,
        default: () => [],
      },
    },
    setup(props) {
      const totalAmountDebt = computed(() =>
        (props.enforcements || []).reduce((sum, item) => sum + (Number(item.amount_debt) || 0), 0)
      );
      const totalBalanceDebt = computed(() =>
        (props.enforcements || []).reduce((sum, item) => sum + (Number(item.balance_debt) || 0), 0)
      );

      const formatCurrency = (value) => {
        return new Intl.NumberFormat('ru-RU', {
          style: 'currency',
          currency: 'RUB',
          maximumFractionDigits: 0,
        }).format(Number(value) || 0);
      };

      const formatDate = (date) => {
        return date ? moment(date).format('DD.MM.YYYY') : 'Нет данных';
      };

      return {
        totalAmountDebt,
        totalBalanceDebt,
        formatCurrency,
        formatDate,
      };
    },
  });
</script>
<style scoped lang="scss">
  .debts-summary__item {
    height: 100%;
    padding: 1rem 1.25rem;

    background: #f4f6fa;
    border-radius: 14px;

    .label {
      display: block;
      margin-bottom: 0.5rem;
      color: #6d7785;
      font-size: 14px;
    }

    strong {
      color: #3e3e3e;
      font-size: 20px;
    }
  }
</style>
